import { FC } from "react"

interface GridInSymbolProps {
  children?: JSX.Element | JSX.Element[]
}

export const GridInSymbolComponent: FC<GridInSymbolProps> = ({ children }) => {
  return <>{children}</>
}
